import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var SpannerIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 12 12",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.186292 2.09604C0.0657099 2.43117 0 2.79248 0 3.16914C0 4.9194 1.41887 6.33827 3.16914 6.33827C3.50074 6.33827 3.82045 6.28734 4.12087 6.19288L8.22795 10.7912C8.92262 11.569 10.1282 11.603 10.8656 10.8656C11.603 10.1282 11.5691 8.92259 10.7913 8.22791L6.19288 4.12085C6.28734 3.82044 6.33827 3.50073 6.33827 3.16914C6.33827 1.41887 4.9194 0 3.16914 0C2.7924 0 2.43103 0.0657354 2.09584 0.186362C2.12879 0.211932 2.16051 0.239846 2.19077 0.270106L3.47701 1.55635C3.86753 1.94687 3.86753 2.58004 3.47701 2.97056L2.97044 3.47713C2.57991 3.86766 1.94675 3.86766 1.55622 3.47714L0.269981 2.19089C0.239743 2.16065 0.211847 2.12896 0.186292 2.09604ZM9.40543 10.3604C9.90551 10.3604 10.3109 9.95497 10.3109 9.45489C10.3109 8.95482 9.90551 8.54942 9.40543 8.54942C8.90536 8.54942 8.49996 8.95482 8.49996 9.45489C8.49996 9.95497 8.90536 10.3604 9.40543 10.3604Z"
  }));
});
SpannerIcon.displayName = 'SpannerIcon';
export default SpannerIcon;